var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_c('Page',{staticClass:"QHPage",attrs:{"total":_vm.total},on:{"on-change":_vm.pageNoChange,"on-page-size-change":_vm.pageSizeChange}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }